import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../api/axios';

const ReservationConfirm = () => {
  const { id, token } = useParams();
  const [status, setStatus] = useState('loading');
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const confirm = async () => {
      try {
        const res = await api.get(`/reservations/accept/${id}/${token}`);
        setData(res.data);
        setStatus(res.data.already_confirmed ? 'already' : 'success');
      } catch (err) {
        setError(err.response?.data?.detail || 'Lien invalide ou expire');
        setStatus('error');
      }
    };
    confirm();
  }, [id, token]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const [y, m, d] = dateStr.split('-');
    return `${d}/${m}/${y}`;
  };

  return (
    <div className="min-h-screen bg-[#f5f1ed] flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-lg max-w-md w-full overflow-hidden" data-testid="confirm-page">
        <div className="bg-[#8B0000] p-6 text-center">
          <h1 className="text-white text-2xl tracking-widest" style={{ fontFamily: "'Cormorant Garamond', serif" }}>LA TAVERNE</h1>
          <p className="text-red-200 text-xs mt-1">Restaurant & Grillades - Cayenne</p>
        </div>
        <div className="p-8 text-center">
          {status === 'loading' && (
            <p className="text-stone-500">Confirmation en cours...</p>
          )}
          {status === 'success' && data && (
            <>
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-green-600 text-3xl">&#10003;</span>
              </div>
              <h2 className="text-xl font-semibold text-stone-800 mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Reservation confirmee !
              </h2>
              <p className="text-stone-600 text-sm mb-6">
                Merci {data.client_name}, votre reservation est confirmee.
              </p>
              <div className="bg-[#fdf8f4] border border-[#e8d5c4] rounded-lg p-4 text-left mb-6">
                <p className="text-xs text-stone-400 mb-1">Date et heure</p>
                <p className="font-bold text-stone-800">{formatDate(data.date)} a {data.heure}</p>
                <p className="text-xs text-stone-400 mt-3 mb-1">Couverts</p>
                <p className="font-bold text-stone-800">{data.couverts} personne{data.couverts > 1 ? 's' : ''}</p>
              </div>
              <p className="text-stone-500 text-xs">Nous vous attendons avec impatience !</p>
            </>
          )}
          {status === 'already' && (
            <>
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-blue-600 text-2xl">&#10003;</span>
              </div>
              <h2 className="text-xl font-semibold text-stone-800 mb-2">Deja confirmee</h2>
              <p className="text-stone-600 text-sm">Cette reservation est deja confirmee. A bientot !</p>
            </>
          )}
          {status === 'error' && (
            <>
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-red-600 text-2xl">&#10007;</span>
              </div>
              <h2 className="text-xl font-semibold text-stone-800 mb-2">Lien invalide</h2>
              <p className="text-stone-600 text-sm">{error}</p>
            </>
          )}
          <Link to="/" className="inline-block mt-6 text-[#8B0000] text-sm hover:underline" data-testid="back-home-link">
            Retour a l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ReservationConfirm;
